import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentFuelColor, selectCurrentFuelFilterId } from '../../../store/geoentity/fuels.selectors'
import { focusGeoentity } from '../../../store/geoentity/geoentity.actions'
import {
  getMarkerMainInformation,
  getPoiPriceDataForMarker,
  poiZIndexWeightCompare
} from '../../../store/geoentity/geoentity.helpers'
import {
  selectCurrentGeoentityId,
  selectFocusedPoiId,
  selectGeoentities,
  selectVdeGeoentities, selectVisitedPoiIds
} from '../../../store/geoentity/geoentity.selectors'
import { navigateToGeoentity } from '../../../store/history/history.actions'
import { useAction } from '../../utils/react-redux'
import { withMapInitialized } from '../map.utils'
import PoiMarker from './PoiMarker'

import { requestUnfocusGeoentity } from '../../../store/geoentity/geoentitySlice'

const usePoisDataForMarkers = vde => {
  const pois = useSelector(vde ? selectVdeGeoentities : selectGeoentities)
  const fuelId = useSelector(selectCurrentFuelFilterId)
  const fuelColor = useSelector(selectCurrentFuelColor)
  const currentPoiId = useSelector(selectCurrentGeoentityId)
  const focusedPoiId = useSelector(selectFocusedPoiId)
  const visitedPoiIds = useSelector(selectVisitedPoiIds)

  const poisCount = pois.length
  const getZIndex = ({ idx, poi }) => {
    const { isCurrent, isFocus } = poi
    if (isFocus) return poisCount + 2
    if (isCurrent) return poisCount + 1
    return poisCount - idx
  }

  return pois
    .map(poi => {
      const isCurrent = poi.id === currentPoiId
      const isFocus = poi.id === focusedPoiId
      const priceData = getPoiPriceDataForMarker(poi, fuelId, fuelColor)

      return {
        ...poi,
        ...getMarkerMainInformation({ poi, price: priceData?.price }),
        ...priceData,
        isCurrent: isCurrent || isFocus,
        visited: visitedPoiIds.includes(poi.id)
      }
    })
    .sort(poiZIndexWeightCompare)
    .map((poi, idx) => ({
      ...poi,
      zIndex: getZIndex({ poi, idx })
    }))
}

// webpack:BrowserOnly
const PoisMarkers = ({ vde }) => {
  const dispatch = useDispatch()
  const markers = usePoisDataForMarkers(vde)
  const execNavigateToGeoentity = useAction(navigateToGeoentity)
  const execFocusGeoentity = useAction(focusGeoentity)

  const navigateToPoi = id => {
    execNavigateToGeoentity({ id, scrollTop: true })
  }

  return (
    <>
      {(markers || []).map(marker => {
        return (
          <PoiMarker
            key={marker.id}
            navigateToPoi={navigateToPoi}
            focusPoi={execFocusGeoentity}
            unfocusPoi={() => dispatch(requestUnfocusGeoentity())}
            {...marker}
          />
        )
      })}
    </>
  )
}

export default withMapInitialized(PoisMarkers)
